import { Fragment, useEffect, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import { InvoiceService } from '../../hoa-don/InvoiceService';
import { CurrencyService } from '../../danh-muc/tien-te/CurrencyService';
import { RegisterInvoiceService } from '../../../service/invoice/RegisterInvoiceService';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';

import { DialogCrup } from '../../hoa-don/component/DialogCrup';
import { DialogView } from '../../hoa-don/component/DialogView';

import { DialogStatement } from '../components/DialogStatement';
import { DialogAttachment } from '../components/DialogAttachment';
import { useSign } from '../../../shared/component/Sign';
import { DialogSendEmail } from '../../hoa-don/component/DialogSendEmail';
import { StatementInvoiceService } from '../StatementInvoiceService';

export const List = () => {

  const header = 'Hoá đơn điều chỉnh trên hệ thống khác';
  const dataKey = 'invoiceId';

  const [displayCrup, setDisplayCrup] = useState(false);
  const [registerInvoice, setRegisterInvoice] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [currencies, setCurrencies] = useState(null);
  const [paymentTypes, setPaymentTypes] = useState(null);

  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [displayStatement, setDisplayStatement] = useState(false);
  const [displayUpload, setDisplayUpload] = useState(false);
  const [displayView, setDisplayView] = useState(false);
  const [documentType, setDocumentType] = useState(InvoiceService.documentType_Adjust);
  const [displayRegisterInvoice, setDisplayRegisterInvoice] = useState(false);
  const [displaySendEmail, setDisplaySendEmail] = useState(false);
  const [data, setData] = useState(null);
  const print = (invoice) => {
    StatementInvoiceService.getByInvoice(invoice.invoiceId).then((res) => {
      window.open(StatementInvoiceService.getPdfUrl(res.id), '_blank');
    })
  }

  useEffect(() => {
    RegisterInvoiceService.getUsingList({ maxResultCount: 1000 }).then(({ items }) => {
      const _registerInvoices = [];
      items.forEach(item => {
        item.label = `${item.symbolCode} - ${item.invoiceTypeName}`;
        _registerInvoices.push(item);
      });
      setRegisterInvoices(_registerInvoices);
      setRegisterInvoice(_registerInvoices[0]);
    });
    CurrencyService.getList({}).then(({ items }) => {
      setCurrencies(items);
    });
    InvoiceService.getPaymentTypes().then(({ items }) => {
      const _paymentTypes = [];
      items.forEach(item => {
        _paymentTypes.push({ value: item.name, label: item.name });
      });
      setPaymentTypes(_paymentTypes);
    });
  }, []);

  const { render: renderDataTable, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    headerColumnGroups: [
      { header: 'Hoá đơn điều chỉnh', colSpan: 8 },
      { header: 'Hoá đơn bị điều chỉnh', colSpan: 4 }
    ],
    columns: [
      { field: 'invoiceSerial', header: 'Ký hiệu', width: 100, matchMode: 'contains' },
      {
        field: 'invoiceNumber', header: 'Số hoá đơn', width: 110, matchMode: 'contains', dataType: 'custom', customCell(rowData): any {
          const text = rowData.invoiceNumber;
          return (
            <span className="underline text-primary" onClick={() => viewInvoice(rowData)}>{text}</span >
          );
        }, style: { justifyContent: 'center' }
      },
      { field: 'invoiceDate', header: 'Ngày hoá đơn', width: 120, dataType: 'date' },
      {
        field: 'sendTaxStatus', header: 'Trạng thái gửi CQT', width: 180, matchMode: 'contains', filterType: 'dropdown', filterOptions: InvoiceService.sendTaxStatuses, dataType: 'custom', customCell(rowData: any): any {
          if ([3, 4, 5].includes(rowData.sendTaxStatus)) {
            return <span className={`underline send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.sendTaxStatuses.find(item => item.value === rowData.sendTaxStatus)?.label}</span>;
          }
          return <span className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.sendTaxStatuses.find(item => item.value === rowData.sendTaxStatus)?.label}</span>;
        }
      },
      {
        field: 'buyerLegalName', header: 'Khách hàng', minWidth: 200, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return rowData.buyerLegalName || rowData.buyerDisplayName;
        }
      },
      {
        field: '', header: 'Biên bản', width: 110, sortable: false, dataType: 'custom', customCell(rowData): any {
          const text = rowData.hasDocument ? rowData.documentNo : 'Lập biên bản';
          const className = rowData.hasDocument ? "underline send-tax-status send-tax-status-4" : "underline text-primary";
          return (
            <span className={className} onClick={() => setDisplayStatement(true)}>{text}</span>
          );
        }, style: { justifyContent: 'center' }
      },
      {
        field: '', header: 'Thao tác', width: 100, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return (
            <div className='flex gap-3'>
              <i className="pi pi-link" title="File dính kèm" onClick={() => setDisplayUpload(true)}></i>
              {rowData.hasDocument && <i className="pi pi-print" title="In hoá đơn" onClick={() => print(rowData)}></i>}
              <i className="pi pi-envelope" title="Gửi email biên bản cho người mua ký" onClick={() => {

                setDisplaySendEmail(true)
                StatementInvoiceService.getByInvoice(rowData.invoiceId).then((res) => {
                  setData(res)
                })
              }
              }></i>
            </div>
          );
        }, style: { justifyContent: 'center' }
      },
      { field: 'relatedInvoiceSerial', header: 'Ký hiệu', width: 100, matchMode: 'contains' },
      {
        field: 'relatedInvoiceNumber', header: 'Số hoá đơn', width: 110, matchMode: 'contains', dataType: 'custom', customCell(rowData): any {
          const text = rowData.relatedInvoiceNumber;
          return text;
        }, style: { justifyContent: 'center' }
      },
      { field: 'relatedInvoiceDate', header: 'Ngày hoá đơn', width: 120, dataType: 'date' },
      { field: 'invoiceNote', header: 'Lý do sai sót', width: 110, matchMode: 'contains' }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      if (!params.sortType) {
        params.sortType = 'DESCEND';
      }
      if (!params.sorting) {
        params.sorting = 'invoiceDate';
      }
      params.IsOtherInvoice = true;
      params.RelatedInvoiceProperty = 2;
      return InvoiceService.getListAdjustments(params);
    },
    selectionMode: 'single'
  });

  const viewInvoice = (rowData) => {
    setSelectedInvoice({
      id: rowData.invoiceId,
      buyerTaxCode: rowData.buyerTaxCode,
      invoiceSerial: rowData.invoiceSerial,
      invoiceNumber: rowData.invoiceNumber
    });
    setDisplayView(true);
  }

  const { renderToolbar } = useToolbar({
    dataKey,
    reloadLazyData,
    otherActions: [
      {
        label: 'Lập hoá đơn điều chỉnh', icon: 'pi pi-fw pi-user-edit', className: 'iam-toolbar', command: () => {
          setDisplayRegisterInvoice(true);
        }
      }
    ]
  });

  const showCrup = () => {
    setDisplayCrup(true);
    setDisplayRegisterInvoice(false);
  }

  const { renderSign, sign } = useSign({ onComplete: reloadLazyData });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}

      {renderSign()}

      <DialogCrup display={displayCrup} setDisplay={setDisplayCrup} reloadLazyData={reloadLazyData}
        registerInvoices={registerInvoices} currencies={currencies} paymentTypes={paymentTypes}
        registerInvoice={registerInvoice} selectedItem={null} invoiceStatus={2}
        sign={sign} />

      <DialogAttachment display={displayUpload} setDisplay={setDisplayUpload} selectedItem={selectedItems} />

      <DialogStatement display={displayStatement} setDisplay={setDisplayStatement} documentType={documentType} selectedItem={selectedItems} reloadLazyData={reloadLazyData} title="điều chỉnh" />

      <DialogView display={displayView} setDisplay={setDisplayView} selectedItem={selectedInvoice} />

      <Dialog header="Chọn ký hiệu" visible={displayRegisterInvoice} style={{ width: '40rem' }} position="top" onHide={() => setDisplayRegisterInvoice(false)}>        <div className="p-fluid formgrid grid">
        <div className="col-12">
          <Dropdown value={registerInvoice} options={registerInvoices} onChange={e => setRegisterInvoice(e.value)} dataKey="id" filter={true} />
        </div>
      </div>
        <div className="flex justify-content-end mt-2">
          <Button label="Chọn" className="p-button-outlined p-button-sm mr-2" onClick={showCrup} />
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplayRegisterInvoice(false)} className="p-button-outlined p-button-secondary p-button-sm" />
        </div>
      </Dialog>
      <DialogSendEmail display={displaySendEmail} setDisplay={setDisplaySendEmail} sendType={8} selectedItems={data} />
    </Fragment>
  )
}
